// Port of api/fuel/app/classes/insights/ratings/overview.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Rating from 'offline/model/rating'

export default Segment.extend({
    name: 'overview',
    priority: 1,
    default_: true,
    requires: [],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var overview = {
            total: 0,
            collectionRated: 0,
            playRated: 0,
            playFirst: 0,
            playChange: 0,
            changePercent: 0,
            changeUp: 0,
            changeDown: 0,
            changeAvg: 0,
            average: 0,
            averageFirst: 0,
            averageSecond: 0
        }

        if (owner.get_count_ratings()) {

            overview.total = Rating.total({
                where: [
                    ['user_id', 'in', userIndex]
                ]
            }, [], 'COUNT(DISTINCT game_id)')

            var totalRatings = Rating.total({
                where: [
                    ['user_id', 'in', userIndex]
                ]
            })

            overview.average = Rating.sum('rating_value', {
                where: [
                    ['user_id', 'in', userIndex]
                ]
            }) / totalRatings

            if (owner.get_count_collection_games()) {

                var collectionRatedResult = Util.query('\
                    SELECT \
                        COUNT(DISTINCT c.game_id) AS c \
                    FROM \
                        collection c \
                        JOIN \
                        rating r \
                        ON \
                        c.game_id = r.game_id \
                        AND \
                        c.user_id = r.user_id \
                        AND \
                        r.user_id IN(' + Util.in(userIndex) + ') \
                        AND \
                        c.collection_expansion = 0 \
                        AND \
                        c.collection_own = 1 \
                ', 'c')

                overview.collectionRated = (100 / owner.get_count_collection_games()) * parseInt(collectionRatedResult[0].c, 10)

            }

            if (owner.get_count_plays_games()) {

                var playRatedResult = Util.query('\
                    SELECT \
                        COUNT(DISTINCT p.game_id) AS c \
                    FROM \
                        rating r \
                        JOIN \
                        play p \
                        ON \
                        p.game_id = r.game_id \
                        AND \
                        p.user_id = r.user_id \
                        AND \
                        r.user_id IN(' + Util.in(userIndex) + ') \
                ', 'c')

                overview.playRated = (100 / owner.get_count_plays_games()) * parseInt(playRatedResult[0].c, 10)

            }

            var revisions = Util.queryFast('\
                SELECT \
                    l.user_id AS u, \
                    l.game_id AS g, \
                    l.log_date AS d, \
                    l.log_context AS c, \
                    l.log_rating AS r, \
                    l.log_previous AS p, \
                    COALESCE(SUM(p2.play_count), 0) AS pl \
                FROM \
                    log_user_rating l \
                    LEFT JOIN \
                    play p2 \
                    ON \
                    p2.user_id = l.user_id \
                    AND \
                    p2.game_id = l.game_id \
                    AND \
                    p2.play_date <= l.log_date \
                WHERE \
                    l.user_id IN(' + Util.in(userIndex) + ') \
                    AND \
                    l.log_initial_sync = 0 \
                GROUP BY \
                    l.user_id, \
                    l.game_id, \
                    l.log_date \
                ORDER BY \
                    l.log_date ASC \
            ')

            var revisionGameAdded = {}
            var revisionGameUpdated = {}

            var playFirst = {}
            var playsUpdate = {}
            var playFirstDate = {}
            var playFirstPlays = {}

            var firstTotal = 0
            var firstCount = 0
            var secondTotal = 0
            var secondCount = 0

            for (var i = 0; i < revisions.length; i++) {
                var revision = revisions[i]

                if (parseInt(revision.c, 10) === Constants.LOG_CONTEXT_UPDATED) {

                    if (parseFloat(revision.r) > parseFloat(revision.p)) {
                        overview.changeUp++
                    } else if (parseFloat(revision.r) < parseFloat(revision.p)) {
                        overview.changeDown++
                    }

                    if (!revisionGameUpdated[revision.u]) revisionGameUpdated[revision.u] = {}
                    if (!revisionGameAdded[revision.u]) revisionGameAdded[revision.u] = {}

                    overview.changeAvg += parseFloat(revision.r) - parseFloat(revision.p)

                    if (!revisionGameUpdated[revision.u][revision.g] && revisionGameAdded[revision.u][revision.g]) {

                        if (!playsUpdate[revision.u]) playsUpdate[revision.u] = []

                        if (playFirstDate[revision.u] && playFirstDate[revision.u][revision.g]) {

                            secondTotal += parseFloat(revision.r)
                            secondCount++

                            playsUpdate[revision.u].push(parseInt(revision.pl, 10) - playFirstPlays[revision.u][revision.g])

                        }

                    }

                    revisionGameUpdated[revision.u][revision.g] = true
                    revisionGameAdded[revision.u][revision.g] = true

                } else if (parseInt(revision.c, 10) === Constants.LOG_CONTEXT_ADDED) {

                    if (!revisionGameAdded[revision.u]) revisionGameAdded[revision.u] = {}
                    revisionGameAdded[revision.u][revision.g] = true

                    if (!playFirst[revision.u]) {
                        playFirst[revision.u] = []
                        playFirstDate[revision.u] = {}
                    }

                    playFirst[revision.u].push(parseInt(revision.pl, 10))

                    firstTotal += parseFloat(revision.r)
                    firstCount++

                    playFirstDate[revision.u][revision.g] = revision.d
                    if (!playFirstPlays[revision.u]) playFirstPlays[revision.u] = {}
                    playFirstPlays[revision.u][revision.g] = parseInt(revision.pl, 10)

                }
            }

            var allAddedGames = {}
            var ukeys = Object.keys(revisionGameAdded)
            for (var ai = 0; ai < ukeys.length; ai++) {
                var userGames = revisionGameAdded[ukeys[ai]]
                var gkeys = Object.keys(userGames)
                for (var gi = 0; gi < gkeys.length; gi++) {
                    allAddedGames[gkeys[gi]] = true
                }
            }
            var addedCount = Object.keys(allAddedGames).length

            var allUpdatedGames = {}
            var ukeys2 = Object.keys(revisionGameUpdated)
            for (var ui = 0; ui < ukeys2.length; ui++) {
                var userGames2 = revisionGameUpdated[ukeys2[ui]]
                var gkeys2 = Object.keys(userGames2)
                for (var gi2 = 0; gi2 < gkeys2.length; gi2++) {
                    allUpdatedGames[gkeys2[gi2]] = true
                }
            }
            var updatedCount = Object.keys(allUpdatedGames).length

            if (addedCount > 0) {
                overview.changePercent = (100 / addedCount) * updatedCount
            }

            var changeDenominator = overview.changeUp + overview.changeDown
            if (changeDenominator > 0) {
                overview.changeAvg = Math.round((overview.changeAvg / changeDenominator) * 100) / 100
            }

            var playFirstFlat = Util.array_flatten(Object.keys(playFirst).map(function(k) { return playFirst[k] }))
            if (playFirstFlat.length) {
                var pfSum = 0
                for (var pi = 0; pi < playFirstFlat.length; pi++) pfSum += playFirstFlat[pi]
                overview.playFirst = Math.round((pfSum / playFirstFlat.length) * 100) / 100
            }

            var playsUpdateFlat = Util.array_flatten(Object.keys(playsUpdate).map(function(k) { return playsUpdate[k] }))
            if (playsUpdateFlat.length) {
                var puSum = 0
                for (var pui = 0; pui < playsUpdateFlat.length; pui++) puSum += playsUpdateFlat[pui]
                overview.playChange = Math.round((puSum / playsUpdateFlat.length) * 100) / 100
            }

            if (firstCount) overview.averageFirst = Math.round((firstTotal / firstCount) * 100) / 100
            if (secondCount) overview.averageSecond = Math.round((secondTotal / secondCount) * 100) / 100

        }

        return {
            overview: overview
        }

    }
})
